G.OutOfMovesInfoPanel = function (x, y) {
  Phaser.Group.call(this, game);
  this.state = game.state.getCurrentState();
  this.position.setTo(x, y);

  if (G.MYSTERYGIFT && G.saveState.mysteryGift_isModeReady()
    && G.saveState.mysteryGift_getCurrentStreak() > 0) {
    this.initMysteryGiftPanel();
  } else {
    this.initRegularPanel();
  }
};

G.OutOfMovesInfoPanel.prototype = Object.create(Phaser.Group.prototype);

G.OutOfMovesInfoPanel.prototype.initRegularPanel = function () {
  if (this.state._removedLifeAtStart) {
    this.gingy = G.makeImage(0, 0, 'sad_gingy_heart_small', 0.5, this);
  } else {
    this.gingy = G.makeImage(0, 0, 'failed_dimond', 0.5, this);
  }

  this.continue = new G.Text(0, 140, OMT.language.getText('Continue?'), {
    style: 'font-purple',
    fontSize: 50,
  }, 0.5, 400);
  this.add(this.continue);
};

G.OutOfMovesInfoPanel.prototype.initMysteryGiftPanel = function () {
  const iconsMap = {
    spiral: 'ui_booster_8',
    vertical: 'ui_booster_4',
    horizontal: 'ui_booster_3',
    cross: 'ui_booster_9',
  };
  const gifts = G.saveState.mysteryGift_getCurrentGifts();

  for (let i = 0; i < 3; i++) {
    const icon = G.makeImage(
      -140 + (i * 140), 0,
      iconsMap[gifts[i]] || 'MysteryGift_EmptyTile', 0.5, this,
    );
    if (iconsMap[gifts[i]]) {
      G.makeImage(-30, 30, 'task_fail', 0.5, icon);
    }
  }

  this.dontLose = new G.Text(0, 140, OMT.language.getText("Don't lose your boost!"), {
    style: 'font-purple',
    fontSize: 50,
  }, 0.5, 400);
  this.add(this.dontLose);
};
